(function ($) {
	const initializeGrid = ($self) => {
		let $gridContainer = $($self).find('.card-grid-container')[0];
		let _ = {
			ajaxConfig: JSON.parse(($($self).attr('ajax-config') ? $($self).attr('ajax-config') : '{}')),
			downloadableCountAction: ($($self).attr('downloadable-count-action') ? $($self).attr('downloadable-count-action') : ''),
			connectedFilters: JSON.parse(($($gridContainer).attr('connected-filters') ? $($gridContainer).attr('connected-filters') : '[]')),
			downloadAllBtn: $self.find('.headline a.cta-button')
		}

		// On click downmload all button
		_.downloadAllBtn.on('click', (event) => {
			event.preventDefault();
			_.downloadAllBtn.attr('fr-status', 'loading');
			$.ajax({
				url: _.ajaxConfig.url,
				method: "POST",
				data: _.ajaxConfig,
				xhrFields : {
					responseType : 'blob'
				},
				dataType : 'binary'
			}).always((jqXHR, status) => {
				_.downloadAllBtn.attr('fr-status', '');
			}).done(function(res) {
				const url = URL.createObjectURL(res); 
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', "resources.zip");
				document.body.append(link);
				link.click();
				document.body.removeChild(link);
				URL.revokeObjectURL(url);
			}).fail(err => {
				console.log('Failed: ' + JSON.stringify(err));
			});
		});

		connectFrontendFilters($self, _);
		refreshDownload($self, _);
	}

	const refreshDownload = ($self, _) => {
		_.downloadAllBtn.attr('fr-status', 'loading');

		let payload = {
			..._.ajaxConfig,
			action: _.downloadableCountAction
		}

		$.ajax({
			url: _.ajaxConfig.url,
			method: "POST",
			data: payload
		}).always((jqXHR, status) => {
			_.downloadAllBtn.attr('fr-status', '');
		}).done(function(res) {
			if(res.data.downloadableResourceCount){
				_.downloadAllBtn.removeAttr('disabled');
			}
			else {
				_.downloadAllBtn.attr('disabled', 'disabled');
			}
		}).fail(err => {
			console.log('Failed: ' + JSON.stringify(err));
		});
	}

	const connectFrontendFilters = ($self, _) => {
		if(!_.connectedFilters || _.connectedFilters.length === 0){
			return;
		}		

		_.connectedFilters.forEach( filter => {
			// On filter changed trigger
			$(`#${filter}`).on('fr:filters-changed', (event, formData) => {
				_.ajaxConfig = {
					..._.ajaxConfig,
					...formData
				}

				refreshDownload($self, _);
			});

			// On filter reset trigger
			$(`#${filter}`).on('fr:filters-reset', (event, formElements) => {
				formElements.forEach(ele => {
					if(_.ajaxConfig.hasOwnProperty(ele)){
						delete _.ajaxConfig[ele];
					}
				});

				refreshDownload($self, _);
			});
		});
	}

	$.fn.resourceCardGrid = function () {
		return this.each((i, el) => {
			const $self = $(el);

			initializeGrid($self);
		});
	}

	$(() => {
		$('.resource-card-grid-module').resourceCardGrid();
	});
})(jQuery);